import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'  // 根路径重定向到登录页
    },
    {
        path: '/login',
        name: 'UserLogin',
        component: Login,
        meta: {
            title: '登录页',
            requiresAuth: false  // 不需要登录验证
        }
    },
    {
        path: '/home',
        name: 'MainHome',
        component: Home,
        meta: {
            title: '首页',
            requiresAuth: true  // 需要登录验证
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

// 路由守卫：在跳转前执行
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title
    }

    // 获取 token（从 localStorage 中读取）
    const token = localStorage.getItem('token')

    // 判断目标页面是否需要登录
    if (to.meta.requiresAuth) {
        // 需要登录的页面
        if (token) {
            // 有 token，允许访问
            next()
        } else {
            // 没有 token，跳转到登录页
            next({
                path: '/login',
                query: { redirect: to.fullPath }  // 记录要跳转的页面，登录后可以返回
            })
        }
    } else {
        // 不需要登录的页面
        if (to.path === '/login' && token) {
            // 如果已经登录，访问登录页时跳转到首页
            next('/home')
        } else {
            next()
        }
    }
})

export default router